export enum ResponseParseMethod {
    JSON = 'json',
    NONE = 'none',
    MANUAL = 'manual',
}
